module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("V")])]), _vm._v("oices. Whispering voices. Hushed words swirling about in the darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Reece’s head ached as if a twenty pound sack of grain pressed upon it and his side felt as if it was pierced with a hot iron.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("What the devil had…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The memories returned, dim at first, then rapidly growing clearer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Lady Anne. Her brothers. No, half brothers. The agonizing pain in his side. Although he had only spoken to Lady Anne, he had been most foully and cowardly attacked from behind by Damon Delasaine.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The man was going to pay for that, and if he had harmed his innocent sister, Delasaine would pay even more. He had to get up and find out what had happened, as well as where the devil he was.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("His eyelids cracked open. The beamed ceiling looked familiar and the stone walls… He was in the chamber in the king’s castle he was sharing with his ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("brothers, and it was very dimly lit. His eyelids fluttered closed again.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Reece?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("That was the voice of his brother, Gervais.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“He’s awake.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("That was his youngest brother, Trevelyan.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“No, he’s not,” Gervais said in what was supposed to pass for a whisper. “He just groaned in his sleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("What time of day was it? Reece wondered as he tried to wet his dry lips to speak. He moved in preparation of sitting up, and the pain sliced through him, wrenching another groan from his desert-dry throat.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I say he "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" awake and we should summon the infirmerer,” Trev whispered, his voice strained from more than the effort of keeping his naturally loud voice soft. “He said we should fetch him when Reece awoke.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“We should wait until we’re sure,” the ever-cautious Gervais retorted. “I don’t want you to go running all over the castle for no reason.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Reece opened his eyes again and put his hand on his side. He was bare chested, with a cloth wrapped about him. A bandage, obviously, and it was damp where the worst pain was. He looked down and saw the blood as he struggled to sit up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Gervais gently pushed him down. “Keep still, brother,” he commanded with no attempt at a muted tone, his voice as firm as a general’s but with relief in it, too. “You’ve lost enough blood, and they punched you in the face, too, the louts.”")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Yes, he remembered that, as anger swept through him, albeit accompanied by humiliation. He should have been more careful of Damon Delasaine and able to triumph over both them. Two on one shouldn’t have made a difference.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Can you see?” Gervais asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Reece nodded and forced his thoughts away from his own anger and shame. “What happened to Lady Anne after they attacked me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Gervais didn’t answer right away. He came around the bed, leaned forward and lightly covered Reece’s left eye with the palm of his hand. “And now?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Yes. Lady Anne—?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Thank God!” Gervais said with a sigh as he moved back and sat on the cot. “We were afraid he’d blinded you in your right eye. How’s your head?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“It hurts.” Reece reached out and grabbed Gervais’s arm. The lunge made him cry out at the sudden jab of pain from his side, but he asked his question with stern authority. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“What of Lady Anne?”")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Taken to her bed, or so her brothers claim,” Trev said from the foot of the cot, reminding Reece he was there.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He didn’t like the sound of that. Either she was avoiding people because she was embarrassed or ashamed, or she had another reason, such as a bruised body, to stay hidden away.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("If her siblings had harmed her in any way, they would rue the day as soon as the wound in his side had healed enough for him to challenge them to com")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("bat, either singly or together. He would be more than prepared for their treachery now.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Damn, Reece, let go! You’re going to break my arm.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Sorry,” he muttered as he released Gervais and lay back down, panting as the pain ebbed. “How long?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“How long since they attacked you?” Gervais asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“It’s midmorning after.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Those damn Delasaines stabbed you in the back,” Trev said, his voice very loud in the quiet of the room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Not exactly the back, Reece knew, although Damon’s blow had been cowardly just the same.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“By the time the king’s guards got there, you were out cold,” Trev continued.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Gervais regarded Reece with woeful sympathy, as if he were a sick baby. “Thank God the dagger ran along a rib, so no serious harm done. All you need is rest and time to heal. Don’t give the tournament another thought. There’ll be others.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Reece stifled another groan, this time of disappointment and dismay. He had planned to distinguish himself at the king’s tournament. No chance of that now, thanks to the Delasaines.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“What about you?” he asked Gervais, who was also to be a competitor.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("His brother shrugged. “As I said, there will be ")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("plenty of tournaments to come. I wanted to stay with you.”")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("So both of their chances for honor and glory had been taken away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“And it was a good thing he did, to stave off the rumors those Delasaines started to spread this morning,” Trev declared. “You won’t believe what they’re saying, those no-good, disgusting—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Leave it, Trev, until he’s more himself,” Gervais ordered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Reece wasn’t in so much pain that he didn’t see the concern flit across Gervais’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“What?” he demanded, once more trying to sit up. “What are they saying?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Don’t worry yourself about anything except healing,” Gervais commanded, again pushing him down, although not so gently this time. “We’ll deal with those blackguards.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The Delasaines were his problem, not Gervais’s and certainly not young Trevelyan’s. “Leave them alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“But Reece—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Until I am better.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("A look of understanding appeared in Gervais’s worried eyes. “Ah. You’ll have your own vengeance, is that it?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("Reece nodded, although vengeance was not precisely the term he would use for what he intended. A lesson was more like. The Delasaines’ anger might have been justifiable, but not the attack, or its sav")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("agery. He would instruct them on the concept of a punishment appropriate to the crime, one at a time. And if they had harmed one hair on Lady Anne’s head, they would learn another lesson.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Trev gasped. “By the saints, I should fetch the infirmerer!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He didn’t wait for his older brothers to concur; he dashed from the room like a startled rabbit.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Regardless of Gervais’s attempts to hold him down, and despite the throbbing in his head, Reece finally managed to sit up. “Now, what exactly are the Delasaines saying?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Gervais frowned, reminding Reece of their father when he was displeased. “I would rather we didn’t talk about this until you’re more yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Tell me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“They’re saying you were…threatening…their sister.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Threatening?” That was bad enough. Unfortunately, he was certain, by Gervais’s tone, that there was more—or worse.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Gervais shrugged, as if the exact wording wasn’t important. “Attacking.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Attacking?”")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Reece’s heart began to pound. That was a very serious charge indeed, yet one that would justify their “punishment,” and so the safest one for them. No one could assault a knight and not have to give a good reason. A simple breech of propriety was not nearly good enough.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Gervais’s expression held resignation, and a confirmation Reece did not really want to see. “Aye, that’s what they’re saying, to excuse what they did. Nobody believes—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“The king?” Reece interjected, naming the one man whose opinion in this business truly mattered, the one man who had the power to reward or punish or accuse as he saw fit. “Surely Henry doesn’t believe it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“We haven’t heard what Henry thinks.” Gervais cleared his throat. “Unfortunately, the Delasaines are related to Eleanor. Distantly, but related.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("That was not good news. She might back them simply for the sake of a family tie.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Reece leaned against the wall behind the cot and closed his eyes again. This was bad. Terrible. With one impulsive act he may have put his whole future in jeopardy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("All his life Reece had had one dream: to be in the king’s retinue, his inner circle, one of his trusted advisors. He could represent the minor lords whose ancestors did not come from the noble families of Normandy but whose forebears had more humble origins, winning their titles by skill and intelligence rather than solely by their birth. Now, by making enemies of relatives of the queen, he might have destroyed his chances.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("Worst of all, if he had troubled himself to find out who the beauty was beforehand, he would have known ")]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("to steer very clear of her, and her vicious brutes of brothers.")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“The French make no protest about the Delasaines’ accusation, of course, because of their relationship to Eleanor. Everyone else refuses to believe them. There have been several arguments already, and I think Blaidd Morgan’s been in three fist-fights.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Oh, God.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Aye, Reece, it’s not good—but they started it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I started it,” Reece muttered. “I shouldn’t have followed her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Harmless, that was.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Obviously, it was not.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Gervais studied him closely, as if trying to read his thoughts. “It’s, um, not like you to talk to a woman you haven’t been introduced to, or even one you have, Reece.” He ran his hand through his shoulder-length hair. “God’s wounds, brother, it’s not like you to talk to a woman at all, especially one as beautiful as that. What got into you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I wish I could say it was the king’s wine,” Reece muttered, feeling the heat of a blush and recalling Blaidd’s teasing comments that made him want to squirm.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I don’t know,” he said at last. He shrugged, then winced.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“You should have at least told us where you were going.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("Reece quirked an eyebrow. “Oh, and you and the ")]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("others would not have joked and teased and made sport of me all the more?”")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Gervais wisely did not even try to disagree.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I shouldn’t have gone in the first place.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Aye, but you cannot change it now. Still, Father isn’t going to be happy, and Mother will have a fit when she sees your face and hears you’ve been stabbed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Gervais always was a master of understatement. His father was going to think he had taken leave of his senses and acted like a fool. As for his wounds, his mother would want to examine him and fuss over him and generally make him feel about six years old.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He gingerly touched his swollen cheek, wondering how he looked. “Is it bad?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“It’ll take a while for the swelling to go down, and you’ve bled in your eye, so it’s as red as a demon’s. The infirmerer says you should regain your strength soon enough, since you are—” Gervais assumed a learned, pompous air “—a healthy young man in the prime of life.” He resumed his normal manner. “Mother and Father will both be glad you’re not dead, of course, but I think maybe we should leave Anne Delasaine out of it when we tell them what happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“How can we?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“The important thing is that you were viciously attacked on a poor pretext.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Reece shook his head. “I made a mistake, and there’s no point lying about it.”")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I’m not saying we should lie,” Gervais retorted, mightily affronted. “I’m simply suggesting that we leave the lady out of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“What reason would you have me give for my beating? And unless you plan to muzzle everyone at court or swear them to secrecy, they will hear the truth eventually. It would be better if they heard it from me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Gervais’s brows lowered as he regarded his brother’s resolute face. “You won’t say you deserved it or some such nonsense?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“The Delasaines were wrong to attack me as they did, but I was wrong to follow Lady Anne and speak to her alone. I will say that to anybody who asks or speaks of what happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Damn your honorable hide,” Gervais muttered as he plucked at Reece’s blanket. “I should have known better than to suggest anything less than the full and complete truth to you. Well, Father will make them sorry, whatever they say.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Reece tensed. “This is for me to deal with, Gervais. My lesson to teach.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Gervais’s brown eyes flared with bright understanding and a warrior’s approval. “I should have known you were going to say that, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Then you agree to let me deal with this matter as I see fit?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Gervais got to his feet and bowed with a flourish. “As you command, my liege, thus it will be.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("“Good,” Reece mumbled, knowing he could trust ")]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("Gervais to keep his word, no matter how jestingly he spoke. “Make sure Trev understands this, too.”")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I will, brother, I will.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Standing at the window of her chamber in the king’s castle assigned to her use during her family’s residence in Winchester, Anne watched the sun set. The rest of the night and a whole day had passed since she had encountered Sir Reece Fitzroy in the corridor.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Closing her eyes, she again saw Damon’s vicious, dishonorable blow. She had grabbed his arm and pulled him back, but he had shaken her off the way a dog might shake a rabbit. Thank God the king’s guards had arrived.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("They had listened to Damon explain, aided by Benedict, as some of the other soldiers carried away an unconscious Sir Reece. Once she knew he was safe, and seeing her half brothers occupied, she had slipped away and fled to her chamber. She had not seen Damon or Benedict since, but someone had turned the key in the lock of the door to her chamber later that night, and she was imprisoned yet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("As the hours had slowly passed, she had hoped Sir Reece’s injuries were not life threatening. He had lost blood, the damp stain on his tunic evidence of that, and a terrible bruise had been forming beneath his eye the last time she had seen him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("She had remembered other things, too—the excitement most of all. She had never felt that way in her life and probably never would again. She doubted any ")]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("of her brother’s choices for a husband would be able to create even an instant’s desire or passion. Unfortunately, if Sir Reece survived—and please God, he must!—she was sure he would never want to have anything to do with her again.")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("How long Damon intended to keep her here without food or water she could not guess, but this was the king’s castle, not Montbleu, so her continued absence would be more difficult to explain. Surely they could not keep her here without food or water for much longer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Anne started when she heard the key in the lock of her bedchamber door, then steeled herself as Damon sauntered inside. She had been right not to expect Lisette, a maidservant from the queen’s household assigned to her upon their arrival, Damon being too parsimonious to bring any servants from Montbleu. In truth, however, she preferred the vivacious, merry Lisette to the dour, ancient maidservant who cared for her at home.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("Her half brother twirled a heavy iron key around his finger as he surveyed the chamber. This room was certainly much finer than the small bedchamber she had at home, and better furnished. In addition to the wide bed with feather tick, there was a dressing table and stool, a chair and bright tapestries on the walls. The coverlet on the bed was silk, and the candles on the table were made of beeswax. In the corner stood the large chest containing the new garments Damon had purchased for her before they came here, fine ")]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("feathers to entrap a rich husband, which was why he had been so uncharacteristically generous.")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Hungry?” Damon asked as he sat in the chair, carelessly crushing a cushion. Still spinning the key around his finger, he threw one leg over the arm and rested his elbow on the other.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Hiding her relief, she kept her expression bland. “I assume from your casual manner that you did not kill Sir Reece, or surely you would be busily plotting your defense at the king’s court.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Damon smiled his evil little smile. “Of course he did not die. I struck to wound, not to kill.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Damon no more had the finesse or skill to strike in such a calculated way than she did, but she hid her skepticism from him, along with her other emotions.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Of course you are hungry,” he answered for her as he tucked the key into the wide leather belt around his waist. “But you will have no food tonight, either. That will teach you to talk to an unworthy young man and interfere in his just punishment.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Even though righteous indignation at his vicious attack on Sir Reece, as well as her subsequent imprisonment, burned inside her, Anne regarded her half brother with a bland expression and stoic silence. He was an arrogant, ambitious fool who had no idea of the magnitude of the possible repercussions from his actions last night, results that had also haunted her thoughts and kept her from sleeping. He couldn’t have, or he wouldn’t be so smug.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("She watched him steadily, and fought to keep the ")]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("full force of her ire from her voice. “For a man who has been calculating my worth for so long, you seem blind to the implications of your attack upon Sir Reece. For one knight to attack another in such a way, and in the king’s own castle, bespeaks extreme provocation. So what will the courtiers believe actually transpired between Sir Reece and me? What could constitute such provocation? Not simply talk. They will think he was doing considerably more—and what, then, will happen to my value as a maiden bride?”")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Damon didn’t look at all upset. “We were completely justified based on the shocking sight of Fitzroy insolently accosting you in the corridor. But have no fear, Anne. I made you quite the martyr. Indeed, you should be pleased and grateful for all that I have said in your defense.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She could well imagine the lies he would spread, falsehoods that would justify what they had done, and no doubt portray her as a helpless victim. “I am to be grateful that you have portrayed me as the meek little lamb in the clutches of the ravening wolf?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Clever girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Yet he was not so clever. “Then what explanation have you given for punishing me?” she asked as she crossed her arms over her chest, as if she could keep her temper in check that way. “I should know it, should I not? Or do you intend to keep me imprisoned until it is time to go back to Montbleu?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("Damon’s smile grew and his eyes gleamed with evil mischief. “I have told everyone that you are so upset ")]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("by Sir Reece’s unwelcome attentions, you have taken to your bed.”")])]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He was, regrettably, a very good liar and she didn’t doubt that most people would believe that explanation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Nevertheless, she dared to raise a skeptical brow. “With no servants to tend to me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“No, for you see, you are a woman of such delicate sensibilities, you cannot bear to be seen by anyone after what happened last night, although you have done nothing wrong. You will speak only to me, and I am doing my best to persuade you to come out. Why, you are even too distraught to eat. I assure you, the women of the court, and all the men save Fitzroy’s brothers and those Welsh friends of his, are most sympathetic.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Damon was cruel, he was greedy, he was a bully, but she could not deny this explanation would probably sound plausible to those who did not know them. “We did nothing wrong, Damon,” she repeated.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Fasting is good for the soul.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And you never fast because you have no soul.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Damon put both feet on the ground and his hands on his knees. He leaned forward, watching her intently. “What did that bastard’s son say to you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“He only wanted to know my name. He knows it well enough now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Damon snorted, his good humor apparently restored, as he slumped back in the chair. “I daresay he does, and I daresay he won’t forget it.” He gave her a sly, knowing look. “Piers is most upset.”")])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("At the mention of her beloved brother’s name, she stiffened.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Damon and Benedict were the children of their father’s first wife. Anne and Piers were born of his second, who had died giving Piers life when Anne was seven years old. Since then, Anne had stood in a mother’s place for him, and her love for Piers was as intense as any mother’s could be.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I would have preferred to tell him what happened myself,” she said, trying not to let Damon see how upset she was.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I could not allow that,” Damon said, his smile thin and smugly satisfied.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("No, he would want to paint his own picture and put his despicable actions in an honorable light.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("It was bad enough to imagine the rumors and gossip flying about the court; she could not bear to think of Piers being fed lies. “What exactly did you tell him?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“The truth—that our family honor was sullied and we punished the man responsible.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“And me? What did you say of my part in it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I said the same to him as I have said to everyone, that Sir Reece insolently accosted you. I told him, as I did all the other nobles, that you were quite innocently set upon.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Damon’s expression darkened. “Do not even think of contradicting a word of what I have said to anybody when I let you out tomorrow—not even Piers—or you know what I shall do.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("Yes, she did know. He had made the same threat ")]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_vm._v("for years, ever since she had been old enough to marry off, or sent to a convent. If she did not do as he said, he would see to it that she never saw Piers again.")])]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Very well, Damon,” she replied, her loathing increasing as it did every time he threatened her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Steepling his fingers, Damon smiled. “You have not asked how we fared in the tournament.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I do not have to.” She could tell by the look of blatant triumph on his face. “You are obviously un-injured, so I assume you were victorious.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I won a fine ransom that amounts to nearly what we spent on you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Damon acted as if she had personally bankrupted the family, but considering how little they had spent on her before deciding it was time to display her at court, she did not think the sum could be so very great.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Damon slapped his hands upon the arms of the chair and heaved himself to his feet. “Tomorrow you may rejoin the court. I would not be so cruel as to prevent you from seeing your beloved Piers on the day of his first melee.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_vm._v("Her heart lifted. Although she had done her best to hide her fears from the rest of her family, she was worried about Piers’s first tournament, when he would be competing with other knights’ squires. Damon and Benedict had taught him what they knew, but they were not good teachers and their lessons were faulty. They depended upon brute strength to win, not wisdom or skill. She dreaded that Piers, thinner and less muscular than they, would discover the hard way that ")]), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_vm._v("rushing in and striking as often as possible was not necessarily a winning method.")])]), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Damon reached out and grabbed her chin, squeezing it hard enough that it brought tears of pain to her eyes. “Make sure you smile at Lord Renfrew when next you see him, Anne. He is most concerned for your welfare and impressed by your maidenly dismay.” Damon’s expression hardened. “And remember this. You agree with everything we say about what happened last night, or you’ll regret it, just as Reece Fitzroy does.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("At the reminder of the cowardly way they had set upon Sir Reece, her temper flared once more.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“You’re bruising the merchandise, Damon,” she muttered despite the pressure of his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He laughed as he let her go. “Merchandise. I like that,” he remarked as he sauntered toward the door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("While she rubbed her aching jaw, he paused and looked back at her over his shoulder. “A commodity to be sold or traded—that’s exactly what you are, and all you’re good for. Never forget that, Anne, no matter how many young fools talk to you.”")])])]), _c('a', {
    attrs: {
      "id": "page42"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page42"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-051af39c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/warriorsladya_ch02.vue
// module id = 78
// module chunks = 0